"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _hr = _interopRequireDefault(require("./hr.style"));

var _useIsAboveBreakpoint = _interopRequireDefault(require("../../hooks/__internal__/useIsAboveBreakpoint"));

var _utils = require("../../style/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

const Hr = ({
  adaptiveMxBreakpoint,
  ml,
  mr,
  ...props
}) => {
  const largeScreen = (0, _useIsAboveBreakpoint.default)(adaptiveMxBreakpoint);
  let marginLeft = ml;
  let marginRight = mr;

  if (adaptiveMxBreakpoint && !largeScreen) {
    marginLeft = 0;
    marginRight = 0;
  }

  return /*#__PURE__*/_react.default.createElement(_hr.default, _extends({
    "data-component": "hr",
    ml: marginLeft,
    mr: marginRight,
    mt: props.mt || 3,
    mb: props.mb || 3
  }, props));
};

Hr.propTypes = {
  /** Filtered styled system margin props */
  ...marginPropTypes,

  /** Breakpoint for adaptive left and right margins (below the breakpoint they go to 0).
   * Enables the adaptive behaviour when set */
  adaptiveMxBreakpoint: _propTypes.default.number
};
var _default = Hr;
exports.default = _default;